import { IGetGenerics } from './types'

export const getGenericsVars: IGetGenerics = {
  state: {
    in: ['Unpublished', 'Published'],
  },
  productType: {
    in: ['Product', 'Produce', 'SpecialIngredient', 'ProcessedIngredient'],
  },
}
